import { gql } from "@urql/core";

import { mutation } from "@/services/lukita";

export default function presignMutation(files) {
  return mutation(
    gql`
      mutation PresignBlobsMutation($input: [PresignBlobsInput!]!) {
        presignBlobs(input: $input) {
          blobs {
            id
            directUploadUrl
            headers
            signedId
          }
        }
      }
    `,
    { input: files },
  );
}
